import * as Sentry from "@sentry/vue";
import { useRuntimeConfig } from "#app";

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();

  Sentry.init({
    app: useNuxtApp().vueApp,
    dsn: "https://146dd872b87b12f56a35fba2494b4a90@o4508740192698368.ingest.de.sentry.io/4508740194467920",
    environment: config.public.env,
    tracesSampleRate: 1.0,
    debug: false,
  });
});
